export default {
    category: {
        cta: "Termékek megtekintése"
    }
}